window.selectVariant = function (element) {
  const variantId = element.dataset.variantId;

  const productCard = element.closest(".product-card__info");
  if (!productCard) return;

  const form = productCard.querySelector("form.shopify-product-form");
  if (!form) return;

  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;

  idInput.value = variantId;

  const sizeLabel = productCard.querySelector(".select-size-label");
  if (sizeLabel) {
    sizeLabel.style.visibility = "hidden";
    sizeLabel.classList.remove("is-error");
  }
};

window.validateSize = function (button) {
  const productCard = button.closest(".product-card__info");
  if (!productCard) return true;

  const form = button.closest("form");
  if (!form) return true;

  const idInput = form.querySelector('input[name="id"]');

  const sizeLabel = productCard.querySelector(".select-size-label");

  if (!idInput || !idInput.value) {
    if (sizeLabel) {
      sizeLabel.style.display = "block";
      sizeLabel.classList.add("is-error");
      sizeLabel.textContent = "Please select size";
    }

    return false;
  }

  if (sizeLabel) {
    sizeLabel.style.visibility = "hidden";
    sizeLabel.classList.remove("is-error");
  }

  return true;
};

// ============================================================
// Infinite Scroll — Collection pages
// ============================================================
(function () {
  "use strict";

  // Holds the active IntersectionObserver so it can be torn down on re-init
  var activeIntersectionObserver = null;

  function tearDown(section) {
    if (activeIntersectionObserver) {
      activeIntersectionObserver.disconnect();
      activeIntersectionObserver = null;
    }
    // Remove any leftover sentinel/spinner/load-more (safety net)
    var old;
    old = section.querySelector(".infinite-scroll-sentinel");
    if (old) old.remove();
    old = section.querySelector(".infinite-scroll-spinner");
    if (old) old.remove();
    old = section.querySelector(".infinite-scroll-load-more");
    if (old) old.remove();
  }

  var AUTO_LOAD_LIMIT = 3;

  function setupInfiniteScroll(section) {
    var productList = section.querySelector("product-list.product-list");
    var paginationEl = section.querySelector(".pagination");
    if (!productList || !paginationEl) return;

    // Hide the standard pagination controls
    paginationEl.hidden = true;

    // Counts how many pages have been auto-loaded (resets on sort/filter)
    var autoLoadCount = 0;

    // Sentinel element — sits right after the product list and triggers loading.
    // NOTE: inserted as a sibling of product-list inside div.collection, NOT as
    // a direct child of the section — this keeps our MutationObserver from
    // firing again when we add these elements.
    var sentinel = document.createElement("div");
    sentinel.className = "infinite-scroll-sentinel";
    productList.insertAdjacentElement("afterend", sentinel);

    // Loading spinner — shown while fetching
    var spinner = document.createElement("div");
    spinner.className = "infinite-scroll-spinner";
    spinner.hidden = true;
    sentinel.insertAdjacentElement("afterend", spinner);

    // "Load More" button — shown after AUTO_LOAD_LIMIT auto-loads.
    // Uses the theme's own button classes so colours, hover effects and
    // typography all match the rest of the storefront automatically.
    var loadMoreBtn = document.createElement("button");
    loadMoreBtn.type = "button";
    loadMoreBtn.className = "infinite-scroll-load-more button button--outline";
    loadMoreBtn.textContent = "Load More";
    loadMoreBtn.hidden = true;
    spinner.insertAdjacentElement("afterend", loadMoreBtn);

    var loading = false;

    function getNextUrl() {
      var link = paginationEl.querySelector('a[rel="next"]');
      return link ? link.href : null;
    }

    // Stop auto-loading: disconnect observer, remove sentinel, show button
    function switchToManual() {
      if (activeIntersectionObserver) {
        activeIntersectionObserver.disconnect();
        activeIntersectionObserver = null;
      }
      sentinel.remove();
      if (getNextUrl()) {
        loadMoreBtn.hidden = false;
      }
    }

    function loadNextPage(triggeredByButton) {
      var url = getNextUrl();
      if (!url || loading) return;

      loading = true;
      spinner.hidden = false;
      if (triggeredByButton) {
        loadMoreBtn.hidden = true;
      }

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          // Append new product cards
          var newProductList = doc.querySelector("product-list.product-list");
          if (newProductList) {
            var fragment = document.createDocumentFragment();
            Array.from(newProductList.children).forEach(function (child) {
              // Remove reveal-on-scroll so cards are immediately visible
              // (the IntersectionObserver on the original product-list has
              //  already fired; newly-appended cards would stay hidden otherwise)
              child.removeAttribute("reveal-on-scroll");
              fragment.appendChild(child);
            });
            productList.appendChild(fragment);
          }

          // Replace pagination inner HTML so getNextUrl() stays up-to-date
          var newPagination = doc.querySelector(".pagination");
          paginationEl.innerHTML = newPagination ? newPagination.innerHTML : "";

          // Re-initialize Smart Wishlist icons for newly appended cards
          if (typeof ReloadSmartWishlist === "function") {
            ReloadSmartWishlist();
          }

          if (!getNextUrl()) {
            // No more pages — clean up everything
            if (activeIntersectionObserver) {
              activeIntersectionObserver.disconnect();
              activeIntersectionObserver = null;
            }
            sentinel.remove();
            loadMoreBtn.hidden = true;
          } else if (triggeredByButton) {
            // Manual load: show the button again for the next page
            loadMoreBtn.hidden = false;
          } else {
            // Auto-load: check if we've hit the limit
            autoLoadCount++;
            if (autoLoadCount >= AUTO_LOAD_LIMIT) {
              switchToManual();
            }
          }
        })
        .catch(function (err) {
          console.error("[InfiniteScroll] Failed to load page:", err);
          // Restore button on error so the user can retry
          if (triggeredByButton) {
            loadMoreBtn.hidden = false;
          }
        })
        .finally(function () {
          loading = false;
          spinner.hidden = true;
        });
    }

    loadMoreBtn.addEventListener("click", function () {
      loadNextPage(true);
    });

    activeIntersectionObserver = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !loading) {
          loadNextPage(false);
        }
      },
      { rootMargin: "300px" },
    );

    activeIntersectionObserver.observe(sentinel);

    // Re-initialize wishlist icons for cards on the freshly rendered page
    // (covers sort/filter re-renders where loadNextPage is not invoked)
    if (typeof ReloadSmartWishlist === "function") {
      ReloadSmartWishlist();
    }
  }

  function init() {
    var section = document.querySelector(".shopify-section--main-collection");
    if (!section) return;

    tearDown(section);
    setupInfiniteScroll(section);

    // When sort/filter fires, the theme fetches a section-only HTML response and
    // calls shopifySection.replaceChildren(...) which completely replaces the
    // section's direct children. Observing childList (non-subtree) on the section
    // catches exactly this event without being triggered by our own sentinel/spinner
    // insertions (which happen deeper in the tree, inside div.collection).
    var mutationObserver = new MutationObserver(function () {
      tearDown(section);
      setupInfiniteScroll(section);
    });
    mutationObserver.observe(section, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ============================================================
// Hide/Show Filters Toggle — Desktop Sidebar Only
// ============================================================
(function () {
  // Event delegation — survives section re-renders triggered by sort/filter
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".filter-toggle-btn");
    if (!btn) return;
    var sectionEl = btn.closest("[id^='shopify-section-']");
    if (!sectionEl) return;
    var hidden = sectionEl.classList.toggle("filters-hidden");
    btn.setAttribute("aria-expanded", hidden ? "false" : "true");
    var label = btn.querySelector(".filter-toggle-label");
    if (label) label.textContent = hidden ? "Show Filters" : "Hide Filters";
  });

  // After sort/filter re-renders the section's children, sync the new button's
  // UI state to match the filters-hidden class still present on the section element.
  function syncBtn(sectionEl) {
    var btn = sectionEl.querySelector(".filter-toggle-btn");
    if (!btn) return;
    var hidden = sectionEl.classList.contains("filters-hidden");
    btn.setAttribute("aria-expanded", hidden ? "false" : "true");
    var label = btn.querySelector(".filter-toggle-label");
    if (label) label.textContent = hidden ? "Show Filters" : "Hide Filters";
  }

  function init() {
    var sectionEl = document.querySelector(".shopify-section--main-collection");
    if (!sectionEl) return;
    new MutationObserver(function () {
      syncBtn(sectionEl);
    }).observe(sectionEl, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ============================================================
// Quick Add Status Label Update on Hover
// ============================================================
(function () {
  "use strict";

  function getStatusLabel(status, qty) {
    if (status === "out_of_stock") return "Out of Stock";
    if (status === "low_stock") return "Only " + qty + " items left";
    return "In Stock";
  }

  document.addEventListener("mouseover", function (e) {
    var sizeBtn = e.target.closest(".quick-add-size-btn");
    if (!sizeBtn) return;

    var figure = sizeBtn.closest(".product-card__figure");
    if (!figure) return;

    var overlay = figure.querySelector(".quick-add-overlay");
    if (!overlay) return;

    var label = overlay.querySelector(".quick-add-overlay__label");
    if (!label) return;

    var status = sizeBtn.getAttribute("data-inventory-status");
    var qty = parseInt(sizeBtn.getAttribute("data-inventory-qty"), 10);
    var nextText = getStatusLabel(status, qty);

    // Mark button as out-of-stock if needed
    if (status === "out_of_stock") {
      sizeBtn.classList.add("is-out-of-stock");
    }

    // Avoid redundant writes to prevent unnecessary visual updates.
    if (label.textContent !== nextText) {
      label.textContent = nextText;
    }
  });

  document.addEventListener("mouseout", function (e) {
    var sizeBtn = e.target.closest(".quick-add-size-btn");
    var sizesWrap = e.target.closest(".quick-add-overlay__sizes");
    if (!sizeBtn && !sizesWrap) return;

    var figure = sizeBtn
      ? sizeBtn.closest(".product-card__figure")
      : sizesWrap.closest(".product-card__figure");
    if (!figure) return;

    var overlay = figure.querySelector(".quick-add-overlay");
    if (!overlay) return;

    var label = overlay.querySelector(".quick-add-overlay__label");
    if (!label) return;

    var overlaySizesWrap = overlay.querySelector(".quick-add-overlay__sizes");
    if (!overlaySizesWrap) return;

    // Do not reset when moving between buttons or through the gap inside the size area.
    var nextTarget = e.relatedTarget;
    if (nextTarget && overlaySizesWrap.contains(nextTarget)) return;

    if (label.textContent !== "Quick Add") {
      label.textContent = "Quick Add";
    }
  });
})();

// ============================================================
// Quick Add on Hover — Desktop Overlay + Mobile Drawer
// ============================================================
(function () {
  "use strict";

  var drawer, drawerTitle, drawerSizes, backdrop;
  var drawerOpen = false;
  var quickAddToastEl = null;
  var quickAddToastTimer = null;

  function getQuickAddToast() {
    if (quickAddToastEl) return quickAddToastEl;

    quickAddToastEl = document.createElement("div");
    quickAddToastEl.className = "quick-add-toast";
    quickAddToastEl.setAttribute("role", "status");
    quickAddToastEl.setAttribute("aria-live", "polite");
    document.body.appendChild(quickAddToastEl);

    return quickAddToastEl;
  }

  function showQuickAddToast(message, isError) {
    var toast = getQuickAddToast();
    toast.textContent = message || "Could not add to cart";
    toast.classList.toggle("is-error", !!isError);
    toast.classList.add("is-visible");

    if (quickAddToastTimer) {
      clearTimeout(quickAddToastTimer);
    }

    quickAddToastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2600);
  }

  // Inject shared UI elements once
  function setup() {
    backdrop = document.createElement("div");
    backdrop.className = "quick-add-drawer-backdrop";
    document.body.appendChild(backdrop);

    drawer = document.createElement("div");
    drawer.className = "quick-add-drawer";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-hidden", "true");
    drawer.innerHTML =
      '<div class="quick-add-drawer__header">' +
      '<p class="quick-add-drawer__title"></p>' +
      '<button type="button" class="quick-add-drawer__close js-qa-close" aria-label="Close">&times;</button>' +
      "</div>" +
      '<div class="quick-add-drawer__sizes"></div>';
    document.body.appendChild(drawer);

    drawerTitle = drawer.querySelector(".quick-add-drawer__title");
    drawerSizes = drawer.querySelector(".quick-add-drawer__sizes");
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn) return;
    if (btn.classList.contains("is-loading")) return;
    btn.classList.add("is-loading");
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    var formData = new FormData();
    formData.set("id", String(variantId));
    formData.set("quantity", "1");
    formData.set("on_success", "force_open_drawer");
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", Shopify.routes.root + "variants/" + variantId);

    fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var serverMessage =
            (result.json && (result.json.description || result.json.message)) ||
            "Could not add to cart";
          throw new Error(serverMessage);
        }

        return fetch(Shopify.routes.root + "cart.js")
          .then(function (cartRes) {
            if (!cartRes.ok) throw new Error("Could not refresh cart state");
            return cartRes.json();
          })
          .then(function (cartContent) {
            cartContent.sections = result.json.sections;
            closeDrawer();
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  onSuccessDo: "force_open_drawer",
                  cart: cartContent,
                },
              }),
            );
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          });
      })
      .catch(function (error) {
        showQuickAddToast(
          (error && error.message) || "Could not add to cart",
          true,
        );
        console.error("[QuickAdd] Could not add to cart", error);
      })
      .finally(function () {
        btn.classList.remove("is-loading");
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      });
  }

  function getDrawerStockLabel(status, qty) {
    if (status === "out_of_stock") return "Out of stock";
    if (status === "low_stock") {
      if (!isNaN(qty) && qty > 0 && qty <= 3) return "Only " + qty + " left";
      return "Few left";
    }
    return "In stock";
  }

  function openDrawer(mobileBtn) {
    var figure = mobileBtn.closest(".product-card__figure");
    var overlay = figure && figure.querySelector(".quick-add-overlay");
    drawerTitle.textContent = "Select Size";
    drawerSizes.innerHTML = "";

    if (overlay) {
      overlay.querySelectorAll(".quick-add-size-btn").forEach(function (btn) {
        var clone = btn.cloneNode(true);
        clone.classList.remove("is-loading");

        var sizeLabel = (btn.textContent || "").trim();
        var status = btn.getAttribute("data-inventory-status") || "in_stock";
        var qty = parseInt(btn.getAttribute("data-inventory-qty"), 10);

        clone.textContent = "";

        var sizeSpan = document.createElement("span");
        sizeSpan.className = "quick-add-size-btn__label";
        sizeSpan.textContent = sizeLabel;

        var stockSpan = document.createElement("span");
        stockSpan.className = "quick-add-size-btn__stock";
        stockSpan.textContent = getDrawerStockLabel(status, qty);

        clone.appendChild(sizeSpan);
        clone.appendChild(stockSpan);
        drawerSizes.appendChild(clone);
      });
    }

    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-open");
    backdrop.classList.add("is-open");
    drawerOpen = true;
    try {
      document.body.style.overflow = "hidden";
    } catch (e) {}
  }

  function closeDrawer() {
    if (!drawerOpen) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    backdrop.classList.remove("is-open");
    drawerOpen = false;
    try {
      document.body.style.overflow = "";
    } catch (e) {}
  }

  // Single delegated listener — no per-card listeners
  document.addEventListener("click", function (e) {
    // Desktop overlay size button
    var sizeBtn = e.target.closest(".product-card__figure .quick-add-size-btn");
    if (sizeBtn) {
      // Prevent desktop overlay click logic on narrower viewports/tablets.
      if (window.innerWidth < 1024) {
        return;
      }

      // Prevent clicking on out-of-stock buttons
      if (sizeBtn.getAttribute("data-inventory-status") === "out_of_stock") {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      addToCart(sizeBtn.dataset.variantId, sizeBtn);
      return;
    }

    // Mobile quick-add button
    var mobileBtn = e.target.closest(".quick-add-mobile-btn");
    if (mobileBtn) {
      e.preventDefault();
      var directId = mobileBtn.getAttribute("data-direct-variant-id");
      if (directId) {
        addToCart(directId, mobileBtn);
      } else {
        openDrawer(mobileBtn);
      }
      return;
    }

    // Drawer size button
    var drawerBtn = e.target.closest(".quick-add-drawer .quick-add-size-btn");
    if (drawerBtn) {
      // Prevent clicking on out-of-stock buttons
      if (drawerBtn.getAttribute("data-inventory-status") === "out_of_stock") {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      addToCart(drawerBtn.dataset.variantId, drawerBtn);
      return;
    }

    // Close triggers
    if (e.target.closest(".js-qa-close") || e.target === backdrop) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawerOpen) closeDrawer();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();
